<template>
  <div class="accountInformationWrap">
    <AccountShow v-if="showCom ==='Account'" />
    <EditPhone v-if="showCom ==='editPhone'" />
    <EditPassword v-if="showCom ==='editPassword'" />
    <ResetPasswordForm v-if="showCom ==='resetPassword'" />
  </div>
</template>

<script>
import AccountShow from "@/components/gerenzhongxin/AccountShow";
import EditPassword from "@/components/gerenzhongxin/EditPassword";
import EditPhone from "@/components/gerenzhongxin/EditPhone";
import ResetPasswordForm from "@/components/gerenzhongxin/ResetPasswordForm";
export default {
  components: {
    AccountShow,
    EditPassword,
    EditPhone,
    ResetPasswordForm,
  },
  data() {
    return {
      showCom: "Account",
    };
  },
  methods: {},
};
</script>

<style>
</style>